import React from 'react';
import ApplicationEntryContainer from 'features/ApplicationEntry';

const ApplicationEntryPage = () => <ApplicationEntryContainer />;

export default ApplicationEntryPage;
